// extracted by mini-css-extract-plugin
export default {"label":"SignUp_label__Jc8qt","closeIcon":"SignUp_closeIcon__982jh"};